var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44482",
    "data-name": "Path 44482",
    d: "M93.079,174.625l-1.94-.65a1.518,1.518,0,0,0-1.11.04,6.951,6.951,0,0,1-7.845-1.381.3.3,0,0,1,.229-.5,8.524,8.524,0,0,0,9.166-9.172c-.048-.286.3-.454.58-.13a7,7,0,0,1,1.3,7.75c-.422.74.44,2.322.61,3.05a.785.785,0,0,1-.99.99m-2.97-10.961a7,7,0,1,0-14,0,6.921,6.921,0,0,0,.646,2.924,1.5,1.5,0,0,1,.046,1.1l-.653,1.945a.783.783,0,0,0,.988.987l1.944-.653a1.5,1.5,0,0,1,1.1.047,6.99,6.99,0,0,0,9.923-6.354",
    transform: "translate(-76.109 -156.665)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMessages);
export default __webpack_public_path__ + "static/media/navbar_messages.4fae1e21728e407129879b67553509a3.svg";
export { ForwardRef as ReactComponent };